import { InputAdornment, IconButton } from "@mui/material"
import { useFormikContext } from "formik"
import { Plus, Minus, Users } from "lucide-mui"
import React from "react"

import { TextField } from "@/components/form"

interface PeopleAmountInputProps {
  name: string
  label?: string
  min?: number
  max?: number
  disabled?: boolean
}

const PeopleAmountInput: React.FC<PeopleAmountInputProps> = ({
  name,
  label = "Seats",
  min = 1,
  max = 20,
  disabled = false,
}) => {
  const { values, setFieldValue } = useFormikContext<any>()
  const value = values[name]

  const handleIncrement = () => {
    const currentValue = value === "" || value === null || value === undefined ? 0 : Number(value)
    if (currentValue < max) {
      void setFieldValue(name, currentValue + 1)
    }
  }

  const handleDecrement = () => {
    const currentValue = value === "" || value === null || value === undefined ? 0 : Number(value)
    if (currentValue > min) {
      void setFieldValue(name, currentValue - 1)
    }
  }

  const currentValue = value === "" || value === null || value === undefined ? 0 : Number(value)

  return (
    <div className="flex items-end gap-2" data-testid="people-amount-input-container">
      <TextField
        name={name}
        label={label}
        type="number"
        startAdornment={
          <InputAdornment position="start">
            <Users className="text-base text-gray-500" />
          </InputAdornment>
        }
        disabled={disabled}
        InputProps={{
          inputProps: {
            min,
            max,
            className:
              "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
          },
        }}
      />
      <IconButton
        onClick={handleDecrement}
        disabled={disabled || currentValue <= min}
        className="h-[32px] w-8 rounded-md border border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-50"
        data-testid="people-amount-input-decrement"
      >
        <Minus className="w-3.5 h-3.5" />
      </IconButton>
      <IconButton
        onClick={handleIncrement}
        disabled={disabled || currentValue >= max}
        className="h-[32px] w-8 rounded-md border border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-50"
        data-testid="people-amount-input-increment"
      >
        <Plus className="w-3.5 h-3.5" />
      </IconButton>
    </div>
  )
}

export default PeopleAmountInput
